/*
  Onglets (blocks/tabs-advanced.liquid)

  Le composant est enregistré globalement depuis theme.liquid : l'éditeur de
  thème injecte le HTML des blocs (ré)activés sans exécuter leurs <script>
  inline, la définition doit donc déjà être présente sur la page.
*/

(() => {

  if (customElements.get('tabs-advanced-component')) {
    return;
  }

  /* Mémorise l'onglet actif de chaque bloc pour le restaurer après un re-rendu de l'éditeur */
  const selectedIndexes = {};

  class TabsAdvancedComponent extends HTMLElement {

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    init() {
      if (!this.isConnected) {
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.tabs-tablist-item-advanced');

        if (tab && this.contains(tab)) {
          this.select(this.tabs.indexOf(tab));
        }
      }, { signal: signal });

      if (window.Shopify && window.Shopify.designMode) {
        /* Dans l'éditeur de thème : afficher l'onglet qui contient le bloc sélectionné */
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) {
            return;
          }

          const content = event.target.closest('.tabs-contents-item-advanced');

          if (content) {
            this.select(this.contents.indexOf(content));
            return;
          }

          const tab = event.target.closest('.tabs-tablist-item-advanced');

          if (tab) {
            this.select(this.tabs.indexOf(tab));
          }
        }, { signal: signal });
      }

      this.select(selectedIndexes[this.dataset.blockId] || 0);
      this.setAttribute('initialized', '');
    }

    get tabs() {
      return Array.from(this.querySelectorAll('.tabs-tablist-item-advanced'));
    }

    get contents() {
      return Array.from(this.querySelectorAll('.tabs-contents-item-advanced'));
    }

    select(index) {
      const tabs = this.tabs;
      const contents = this.contents;

      if (index < 0) {
        return;
      }

      index = Math.min(index, Math.max(tabs.length, contents.length) - 1);

      tabs.forEach((tab, i) => {
        if (i === index) {
          tab.setAttribute('selected', '');
        } else {
          tab.removeAttribute('selected');
        }
      });

      contents.forEach((content, i) => {
        if (i === index) {
          content.setAttribute('selected', '');
        } else {
          content.removeAttribute('selected');
        }
      });

      selectedIndexes[this.dataset.blockId] = index;
    }

  }

  customElements.define('tabs-advanced-component', TabsAdvancedComponent);

  if (window.Shopify && window.Shopify.designMode) {
    /* Après un re-rendu de section, le DOM peut être morphé sans déclencher
       connectedCallback ni conserver les attributs posés en JS : on ré-initialise. */
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('tabs-advanced-component').forEach((tabs) => tabs.init());
    });
  }

})();
